const it = {
  // Navigation
  nav: {
    vista3d: "Vista 3D",
    videocam: "Video Cam",
    smartdomo: "SmartDomo",
    reportSensori: "Report Sensori",
    apparati: "Apparati",
    calendario: "Calendario",
    manutenzioni: "Manutenzioni",
    ticket: "Ticket",
    assistente: "Assistente",
    inventario: "Inventario",
    veicoli: "Veicoli",
    setup: "Setup",
    utenti: "Utenti",
  },
  // Header
  header: {
    title: "SmartDomo",
    subtitle: "Gestione Intelligente Edifici",
    admin: "Amministratore",
    user: "Utente",
    logout: "Esci",
  },
  // Login
  auth: {
    title: "Accedi",
    subtitle: "Inserisci le tue credenziali per continuare",
    username: "Username",
    password: "Password",
    login: "Accedi",
    loggingIn: "Accesso in corso...",
    error: "Credenziali non valide",
    userNotFound: "Utente non trovato",
    wrongPassword: "Password errata",
    copyright: "SmartDomo - Gestione Edifici Intelligenti",
  },
  // Common
  common: {
    save: "Salva",
    cancel: "Annulla",
    delete: "Elimina",
    edit: "Modifica",
    add: "Aggiungi",
    search: "Cerca",
    filter: "Filtra",
    close: "Chiudi",
    confirm: "Conferma",
    loading: "Caricamento...",
    noData: "Nessun dato disponibile",
    actions: "Azioni",
    status: "Stato",
    name: "Nome",
    description: "Descrizione",
    category: "Categoria",
    date: "Data",
    notes: "Note",
    details: "Dettagli",
    back: "Indietro",
    next: "Avanti",
    previous: "Precedente",
    all: "Tutti",
    active: "Attivo",
    inactive: "Inattivo",
    online: "Online",
    offline: "Offline",
    yes: "Si",
    no: "No",
    or: "o",
    of: "di",
    total: "Totale",
    export: "Esporta",
    import: "Importa",
    download: "Scarica",
    upload: "Carica",
    refresh: "Aggiorna",
    error: "Errore",
    success: "Successo",
    warning: "Attenzione",
    info: "Info",
  },
  // Dashboard / SmartDomo
  dashboard: {
    title: "Dashboard SmartDomo",
    devices: "Dispositivi",
    totalDevices: "Dispositivi Totali",
    onlineDevices: "Dispositivi Online",
    offlineDevices: "Dispositivi Offline",
    warnings: "Avvertenze",
    consumption: "Consumo",
    dailyConsumption: "Consumo Giornaliero",
    monthlyConsumption: "Consumo Mensile",
    realTimeConsumption: "Consumo in Tempo Reale",
    energyMonitor: "Monitor Energia",
    temperature: "Temperatura",
    humidity: "Umidita",
    power: "Potenza",
    voltage: "Tensione",
    current: "Corrente",
    battery: "Batteria",
    doorState: "Stato Porta",
    open: "APERTA",
    closed: "CHIUSA",
    on: "ACCESO",
    off: "SPENTO",
    switchOn: "accendere",
    switchOff: "spegnere",
    clickTo: "clicca per",
    changingState: "Cambio stato...",
    lastMovement: "Ultimo movimento",
    today: "Oggi",
    month: "Mese",
    maintenance: "Manutenzioni",
    alerts: "Allarmi",
    sensors: "Sensori",
    monitoredSensors: "Sensori Monitorati",
    connectedIntegrations: "Integrazioni Connesse",
    systemStatus: "Stato Sistema",
  },
  // Elettrodomestici / Apparati
  appliances: {
    title: "Gestione Apparati",
    addNew: "Nuovo Apparato",
    editAppliance: "Modifica Apparato",
    brand: "Marca",
    model: "Modello",
    serialNumber: "Numero di Serie",
    position: "Posizione",
    purchaseDate: "Data Acquisto",
    warrantyExpiry: "Scadenza Garanzia",
    purchaseCost: "Costo Acquisto",
    currentValue: "Valore Attuale",
    consumption: "Consumo Orario (kW)",
    dailyUsage: "Ore Uso Giornaliero",
    smartPlug: "Smart Plug",
    provider: "Fornitore",
    noAppliances: "Nessun apparato registrato",
    linkedDevice: "Dispositivo Collegato",
    invoice: "Fattura",
    documents: "Documenti",
    manual: "Manuale",
    photos: "Foto",
    videos: "Video",
    instructions: "Istruzioni",
    serviceCenter: "Centro Assistenza",
    other: "Altro",
    climate: "Clima/Riscaldamento",
    kitchen: "Cucina",
    lighting: "Illuminazione",
    security: "Sicurezza",
    entertainment: "Intrattenimento",
    cleaning: "Pulizia",
    garden: "Giardino",
    general: "Generale",
    warranty: "Garanzia",
    warrantyActive: "In Garanzia",
    warrantyExpired: "Garanzia Scaduta",
    deleteConfirm: "Sei sicuro di voler eliminare questo apparato?",
  },
  // Manutenzioni
  maintenance: {
    title: "Gestione Manutenzioni",
    addNew: "Nuova Manutenzione",
    editMaintenance: "Modifica Manutenzione",
    type: "Tipo",
    scheduled: "Programmata",
    completed: "Completata",
    inProgress: "In Corso",
    pending: "In Attesa",
    cancelled: "Annullata",
    priority: "Priorita",
    high: "Alta",
    medium: "Media",
    low: "Bassa",
    assignedTo: "Assegnato a",
    dueDate: "Data Scadenza",
    completedDate: "Data Completamento",
    cost: "Costo",
    noMaintenance: "Nessuna manutenzione registrata",
    appliance: "Apparato",
    history: "Storico",
    deleteConfirm: "Sei sicuro di voler eliminare questa manutenzione?",
  },
  // Tickets
  tickets: {
    title: "Gestione Ticket",
    newTicket: "Nuovo Ticket",
    editTicket: "Modifica Ticket",
    subject: "Oggetto",
    message: "Messaggio",
    openTicket: "Apri Ticket",
    closeTicket: "Chiudi Ticket",
    resolved: "Risolto",
    open: "Aperto",
    closed: "Chiuso",
    inProgress: "In Lavorazione",
    noTickets: "Nessun ticket presente",
    priority: "Priorita",
  },
  // Calendar
  calendar: {
    title: "Calendario Manutenzioni",
    today: "Oggi",
    month: "Mese",
    week: "Settimana",
    day: "Giorno",
    noEvents: "Nessun evento",
    months: ["Gennaio", "Febbraio", "Marzo", "Aprile", "Maggio", "Giugno", "Luglio", "Agosto", "Settembre", "Ottobre", "Novembre", "Dicembre"],
    days: ["Lun", "Mar", "Mer", "Gio", "Ven", "Sab", "Dom"],
  },
  // Sensors
  sensors: {
    title: "Report Sensori",
    temperature: "Temperatura",
    humidity: "Umidita",
    energy: "Energia",
    noData: "Nessun Dato Storico",
    collectData: "Raccogli Dati",
    collecting: "Raccolta in corso...",
    lastHour: "Ultima Ora",
    last24h: "Ultime 24h",
    last7d: "Ultimi 7 Giorni",
    last30d: "Ultimi 30 Giorni",
    chart: "Grafico",
    table: "Tabella",
    sensorType: "Tipo Sensore",
    readings: "Letture",
    average: "Media",
    min: "Minimo",
    max: "Massimo",
  },
  // Vehicles
  vehicles: {
    title: "Tracciamento Veicoli",
    noVehicles: "Nessun veicolo trovato",
    speed: "Velocita",
    lastUpdate: "Ultimo Aggiornamento",
    plateNumber: "Targa",
    moving: "In Movimento",
    stopped: "Fermo",
    engineOn: "Motore Acceso",
    engineOff: "Motore Spento",
  },
  // 3D View / Matterport
  matterport: {
    title: "Spazi 3D",
    pois: "POI",
    sensors: "Sensori",
    spaces: "Spazi",
    addSpace: "Spazio",
    goToPoi: "Vai al POI",
    syncCloud: "Sync Cloud",
    sdkConnected: "SDK Connesso",
    sdkDisconnected: "SDK Disconnesso",
    liveData: "Dati Live",
    linkedDevice: "Collegato",
    notSynced: "Non sync",
    noSensorLinked: "Nessun sensore collegato",
    navigating: "Navigazione...",
    destination: "Destinazione raggiunta!",
  },
  // Property / Setup
  setup: {
    title: "Configurazione Proprieta",
    propertyName: "Nome Proprieta",
    address: "Indirizzo",
    integrations: "Integrazioni",
    connected: "Connesso",
    disconnected: "Disconnesso",
    connect: "Collega",
    disconnect: "Scollega",
    matterportSpaceId: "Matterport Space ID",
    matterportSdkKey: "Matterport SDK Key",
    saveChanges: "Salva Modifiche",
    saving: "Salvataggio...",
    tokenExpired: "Token scaduto",
    reconnect: "Riconnetti",
  },
  // Users
  users: {
    title: "Gestione Utenti",
    addUser: "Nuovo Utente",
    editUser: "Modifica Utente",
    username: "Nome Utente",
    email: "Email",
    role: "Ruolo",
    admin: "Amministratore",
    user: "Utente",
    password: "Password",
    fullName: "Nome Completo",
    deleteConfirm: "Sei sicuro di voler eliminare questo utente?",
  },
  // Video Camera
  videocam: {
    title: "Gestione Telecamere",
    liveView: "Vista Live",
    snapshot: "Istantanea",
    refreshing: "Aggiornamento...",
    noCameras: "Nessuna telecamera configurata",
    lastCapture: "Ultima Cattura",
  },
  // Assistant
  assistant: {
    title: "Chat Assistente",
    placeholder: "Scrivi un messaggio...",
    send: "Invia",
    thinking: "Sto pensando...",
    welcome: "Assistente SmartBuilding",
    description: "Chiedi qualsiasi cosa sui tuoi elettrodomestici, manutenzioni o impostazioni.",
  },
  // Language
  language: {
    it: "Italiano",
    en: "English",
    fr: "Francais",
    es: "Espanol",
    select: "Lingua",
  },
};

export default it;
